import {AlertIcon} from '@primer/octicons-react'
import {Blankslate, SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './shared/ForYouItem.module.css'

export function ForYouSectionSkeleton() {
  return (
    <div className="d-flex gap-3 flex-column" aria-busy="true">
      {[0, 1].map(i => (
        <div key={i} className="d-flex flex-column gap-2">
          <SkeletonText size="titleSmall" style={{width: 120}} />
          <ul className="List-style-none p-0 m-0 d-flex flex-column gap-2">
            {[0, 1].map(j => (
              <li key={j} className={styles.container}>
                <div className={styles.headerRow}>
                  <SkeletonBox height="28px" width="28px" />
                  <SkeletonBox height="16px" width="16px" />
                  <span className={styles.headerText}>
                    <SkeletonText size="bodyMedium" />
                    <SkeletonText size="bodySmall" />
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}

export function ForYouSectionError() {
  return (
    <Blankslate size="small" border>
      <Blankslate.Visual>
        <AlertIcon size="medium" />
      </Blankslate.Visual>
      <Blankslate.Heading as="h3">Unable to load this section</Blankslate.Heading>
      <Blankslate.Description>Try reloading the page.</Blankslate.Description>
    </Blankslate>
  )
}
